import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IFetchStatus } from 'types/rest/IFetchStatus';
import { titleReportInitialState } from './interfaces';
import { TOrderPayload } from '../../../types/order/vendorDashboard/TOrderPayload';
import { ITitleReportData } from '../../../ui-toolkit/orders/interfaces/titleReport/ITitleReport';

export const titleReportReducer = createSlice({
  name: 'titleReport',
  initialState: titleReportInitialState,
  reducers: {
    setTitleReportAction: (state, action: PayloadAction<ITitleReportData>) => {
      state.titleReport = action.payload;
    },
    setTitleReportFetchStatusAction: (state, action: PayloadAction<IFetchStatus>) => {
      state.titleReportFetchStatus = action.payload;
    },
    setTitleReportErrorAction: (state, action: PayloadAction<string | null>) => {
      state.titleReportError = action.payload;
    },
    setTitleReportExistAction: (state, action: PayloadAction<TOrderPayload<boolean>>) => {
      state.titleReportExist[action.payload.orderId] = action.payload.value;
    },
  },
});
export const {
  setTitleReportAction,
  setTitleReportErrorAction,
  setTitleReportFetchStatusAction,
  setTitleReportExistAction,
} = titleReportReducer.actions;
